<template>
    <div style="margin-top: 50px">
        <div>
            <label>{{$t('label.top_users_wage_chart')}}</label>
        </div>
      <div id="core_users_chart" class="container-fluid">
        <div class="row" v-if="core_loading">
          <div class="col-md-12 card bg-white my-4">
            <div class="history-chart card bg-white d-flex flex-row align-items-center justify-content-center">
              <div class="text-center mx-3">
                {{ $t('datatable.records.processing') }}
              </div>
                <div class="spinner-border text-info" role="status">
                  <span class="sr-only"></span>
                </div>
            </div>
          </div>
        </div>
        <div class="row" v-else>
          <div class="col-md-12 card bg-white my-4">
            <div class="history-chart card bg-white">
              <canvas ref="canvas" :height="'600px'"></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { Line } from "vue-chartjs";
import { reportService } from '@/common/api.service'
import Label from "@/components/elements/form/label.vue";
export default {
  name: "coreTopUsersChart",
    components: {Label},
  extends: Line,
    props: {
        query: {
            type: Object,
            required: true
        }
    },
  data() {
    return {
      date_axis: [],
      usersOne: [],
      userTwo: [],
      userThree: [],
      userFour: [],
      userFive: [],
        users: [],
      core_loading: true,
    };
  },
  async mounted() {
    await reportService.fetchCoreTopUsersWageChart(this.query)
      .then((res) => {
        this.date_axis = res.data.data.date_axis;
        this.users = res.data.data.user_axis;
        // this.usersOne = res.data.data.user_axis[0];
        // this.userTwo = res.data.data.user_axis[1];
        // this.userThree = res.data.data.user_axis[2];
        // this.userFour = res.data.data.user_axis[3];
        // this.userFive = res.data.data.user_axis[4];
        this.core_loading = false;
      })
      .catch((e) => {
        console.log(e);
      });

    let data = [];

      for (let i= 0; i < this.users.length; i++) {
          data.push({
              label: this.users[i].user_name,
              data: this.users[i].total_per_days,
              borderColor: [this.randomColor()],
              borderWidth: 1.5,
              fill: false,
          })
      }

    await this.renderChart(
      {
        labels: this.date_axis,
        datasets: data,
      },
      {
        // responsive: true,
        lineTension: 0.1,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                padding: 25,
              },
            },
          ],
        },
      }
    );
  },
    methods: {
      rgbToHex(rgb) {
          let hex = rgb.toString(16);
          if (hex.length < 2) {

              hex = "0" + hex;
          }
          return hex;
      },
      randomColor(){
          const r = Math.floor(Math.random() * 200);
          const g = Math.floor(Math.random() * 200);
          const b = Math.floor(Math.random() * 200);
          return "#" + this.rgbToHex(r) + this.rgbToHex(g) + this.rgbToHex(b);
      }
    }
};
</script>

<style scoped>
.history-chart {
  width: 100%;
  margin: 0.7rem auto;
}
</style>
